angular.module( 'acme.view.application.partners.orders.detail', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.numeric',
  'acme.view.application.partners.orders.detail.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var partnersOrdersDetail = {
        name: 'application.partners.orders.detail',
        url: '/:accountId/detail/:id',
        views: {
          "subview-main": {
            controller: 'PartnersOrdersDetailController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/partners/orders/detail/detail.tpl.html'
          }
        },
        data: {
          pageTitle: 'Organization Order Details'
        },
        resolve: {
          OrderData: ['$stateParams', 'ApiService', function ($stateParams, ApiService) {
            return ApiService.orders.detail($stateParams.id);
          }]
        }
      };

    $stateProvider
      .state(partnersOrdersDetail);
});
